import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
  InputLabel,
  useMediaQuery,
  useTheme,
  Divider,
  Drawer,
} from "@mui/material";

function Filters({
  selectedColors,
  setSelectedColors,
  selectedLines,
  setSelectedLines,
  colorOptions,
  lineOptions,
}) {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.down("lg"));

  const filtersActive = selectedColors.length > 0 || selectedLines.length > 0;

  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const handleColorChange = (event) => {
    setSelectedColors(event.target.value);
  };

  const handleLineChange = (event) => {
    setSelectedLines(event.target.value);
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Search Filters
      </Typography>

      <Box display="flex" flexDirection="column" gap={2}>
        {isLargeScreen ? (
          <>
            <Button
              variant={"outlined"}
              color={filtersActive ? "error" : "black"}
              onClick={toggleDrawer(true)}
            >
              {filtersActive ? "Filters Active" : "Open Filters"}
            </Button>

            <Drawer
              anchor="right"
              open={drawerOpen}
              onClose={toggleDrawer(false)}
            >
              <Box width={300} p={2}>
                {/* Colors Filter */}
                <Typography variant="h6" gutterBottom>
                  Select Filters
                </Typography>
                <FormControl fullWidth margin="normal">
                  <InputLabel id="color-select-label" shrink>
                    Colors
                  </InputLabel>
                  <Select
                    labelId="color-select-label"
                    id="color-select"
                    label="Colors"
                    multiple
                    value={selectedColors}
                    onChange={handleColorChange}
                    displayEmpty
                    renderValue={(selected) =>
                      selected.length === 0 ? (
                        <span style={{ color: "#aaa" }}>Select colors...</span>
                      ) : (
                        selected.join(", ")
                      )
                    }
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 300,
                        },
                      },
                    }}
                    sx={{
                      backgroundColor: "#fafafa",
                      borderRadius: 1,
                      minHeight: 56,
                      "& .MuiSelect-select": {
                        paddingTop: "10px",
                        paddingBottom: "10px",
                      },
                    }}
                  >
                    {colorOptions.map((color) => (
                      <MenuItem key={color} value={color}>
                        <Checkbox
                          checked={selectedColors.includes(color)}
                          sx={{
                            color: "black",
                            "&.Mui-checked": {
                              color: "black",
                            },
                          }}
                        />
                        <Typography>{color}</Typography>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* Styles Filter */}
                <FormControl fullWidth margin="normal">
                  <InputLabel id="line-select-label" shrink>
                    Lines
                  </InputLabel>
                  <Select
                    labelId="line-select-label"
                    id="line-select"
                    label="Lines"
                    multiple
                    value={selectedLines}
                    onChange={handleLineChange}
                    displayEmpty
                    renderValue={(selected) =>
                      selected.length === 0 ? (
                        <span style={{ color: "#aaa" }}>Select lines...</span>
                      ) : (
                        selected.join(", ")
                      )
                    }
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 300,
                        },
                      },
                    }}
                    sx={{
                      backgroundColor: "#fafafa",
                      borderRadius: 1,
                      minHeight: 56,
                      "& .MuiSelect-select": {
                        paddingTop: "10px",
                        paddingBottom: "10px",
                      },
                    }}
                  >
                    {lineOptions.map((line) => (
                      <MenuItem key={line} value={line}>
                        <Checkbox
                          checked={selectedLines.includes(line)}
                          sx={{
                            color: "black",
                            "&.Mui-checked": {
                              color: "black",
                            },
                          }}
                        />
                        <Typography>{line}</Typography>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Drawer>
          </>
        ) : (
          <>
            {/* Colors Filter */}
            <Card variant="outlined">
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Colors
                </Typography>
                <FormControl component="fieldset">
                  <FormGroup>
                    {colorOptions.map((color) => (
                      <FormControlLabel
                        key={color}
                        control={
                          <Checkbox
                            sx={{
                              color: "black",
                              "&.Mui-checked": {
                                color: "black",
                              },
                            }}
                            checked={selectedColors.includes(color)} // for color checkboxes
                            onChange={(e) => {
                              const newColors = e.target.checked
                                ? [...selectedColors, color]
                                : selectedColors.filter((c) => c !== color);
                              setSelectedColors(newColors);
                            }}
                          />
                        }
                        label={color}
                      />
                    ))}
                  </FormGroup>
                </FormControl>
              </CardContent>
            </Card>

            {/* Lines Filter */}
            <Card variant="outlined">
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Styles
                </Typography>
                <FormControl component="fieldset">
                  <FormGroup>
                    {lineOptions.map((line) => (
                      <FormControlLabel
                        key={line}
                        control={
                          <Checkbox
                            sx={{
                              color: "black",
                              "&.Mui-checked": {
                                color: "black",
                              },
                            }}
                            checked={selectedLines.includes(line)} // for line checkboxes
                            onChange={(e) => {
                              const newLines = e.target.checked
                                ? [...selectedLines, line]
                                : selectedLines.filter((l) => l !== line);
                              setSelectedLines(newLines);
                            }}
                          />
                        }
                        label={line}
                      />
                    ))}
                  </FormGroup>
                </FormControl>
              </CardContent>
            </Card>
          </>
        )}
      </Box>
      <Divider variant="middle" sx={{ py: 2 }} />
    </Box>
  );
}

export default Filters;
